import { useContext } from 'react';

import { DrawerInstanceContext } from './DrawerProvider';

export const useDrawerInstance = () => {
  return useContext(DrawerInstanceContext);
};
